export const common = {
	//Menu
	"menu.play": "Играй",
	"menu.ranking": "Класиране",
	"menu.prizes": "Награди",
	"menu.rules": "Правила",
	"menu.leagues": "Лиги",
	"menu.betwayAccount": "Betway Акаунт",
	"menu.terms": "Общи условия",

	//Play
	"play.heroTitle": "Предскажи всеки резултат от мач и спечели награди!",
	"play.heroSubtitle": "Кой отбор ще спечели? Колко гола ще вкарат? Предскажи сега и се състезавай с приятелите си!",
	"play.playNow": "Играй сега",
	"play.seePrizes": "Виж наградите",
	"play.statistics": "Статистики",
	"play.lastMatches": "Последните 5 мача на всеки отбор",
	"play.stats": "Статистика",

	//Ranking
	"ranking.season": "Сезон",
	"ranking.weekly": "Седмично",
	"ranking.selectType": "Избери тип класиране",
	"ranking.selectWeek": "Избери седмица",
	"ranking.myPosition": "Моята позиция",
	"ranking.points": "Точки",
	"ranking.rank": "Ранг",
	"ranking.topMembers": "Топ 20 членове",
	"ranking.noRanking": "Все още няма класация.",
	"ranking.competitionStart": "След като започне състезанието, всички потребители, които играха Score Predict, ще бъдат класирани тук.",
	"ranking.loadMore": "Зареди Още",
	"ranking.loading": "Зарежда...",

	//Leagues
	"leagues.heroTitle": "Състезавай се срещу приятелите си или се присъедини към публични лиги!",
	"leagues.heroSubtitle": "Кой има най-добрите умения за прогнози? Създай или се присъедини към лига, за да разбереш!",
	"leagues.createLeague": "Създай лига",
	"leagues.joinLeague": "Присъедини се към лига",
	"leagues.createLeagueButton": "Създай лига",
	"leagues.joinLeagueButton": "Присъедини се към лига",
	"leagues.enterName": "Въведи име на лигата",
	"leagues.enterCode": "Въведи код за покана",
	"leagues.myLeagues": "Моите лиги",
	"leagues.member": "член",
	"leagues.members": "членове",
	"leagues.membersCapital": "Членове",
	"leagues.league": "Лига",
	"leagues.shareCodeText": "Приятелите ти могат да се присъединят към лигата ти, като използват този код:",
	"leagues.shareCode": "Сподели код",
	"leagues.editLeague": "Редактирай лига",
	"leagues.delete": "Изтрий",
	"leagues.leave": "Напусни",
	"leagues.deleteWarning": "Цялата история и членовете ще бъдат окончателно изтрити.",
	"leagues.leaveWarning": "Точките ти за прогнози и класирането ще бъдат изтрити.",
	"leagues.confirmDelete": "Да, изтрий",
	"leagues.confirmLeave": "Да, напусни",
	"leagues.cancel": "Отказ",
	"leagues.ban": "Забрани",
	"leagues.edit": "Редактирай",
	"leagues.save": "Запази",

	//Errors
	"errors.savingPredictions": "Грешка при запазване на прогнозите",

	//Predictions
	"predictions.successModal.title": "Прогнозите са потвърдени!",
	"predictions.successModal.subtitle": "Прогнозите ти бяха запазени успешно!",
	"predictions.successModal.close": "Затвори",
	"predictions.seasonEnd.title": "Сезонът завърши!",
	"predictions.seasonEnd.message":
		"Това е всичко за този сезон на BW ScorePredict — страхотна работа! Поздравления на нашия голям победител, [username], който спечели пътуване за двама да гледа Арсенал на живо на Emirates Stadium. Докато действието прави кратка почивка, ние вече се подготвяме за следващия кръг. Следете за актуализации и се подгответе да се върнете с още по-точни прогнози.",
	"predictions.seasonEnd.subtitle": "Не можем да чакаме да те имаме обратно в играта!",
	"predictions.seasonEnd.myPosition": "Моята позиция",
	"predictions.seasonEnd.points": "Точки",
	"predictions.seasonEnd.rank": "Ранг",
	"predictions.seasonEnd.topMembers": "Топ 10 членове",
	"predictions.countdown.deadline": "Краен срок",
	"predictions.countdown.deadlineMissed": "Пропуснат краен срок",
	"predictions.countdown.matchweekDeadline": "Краен срок на кръга",
	"predictions.countdown.deadlineMissedMessage":
		"Не направи прогнозите си за тази седмица, така че не бяха спечелени точки - но винаги има следваща седмица за възстановяване!",
	"predictions.countdown.days": "ДНИ",
	"predictions.countdown.hours": "ЧАСОВЕ",
	"predictions.countdown.minutes": "МИН.",
	"predictions.countdown.seconds": "СЕК.",
	"predictions.bonusFooter.loadingOdds": "Зареждане на коефициенти...",
	"predictions.bonusFooter.draw": "Равенство",
	"predictions.bonusFooter.unknown": "Неизвестно",
	"predictions.bonusFooter.oddsToWin": "Коефициенти за победа",
	"predictions.roundSelector.previousRound": "Предишен кръг",
	"predictions.roundSelector.nextRound": "Следващ кръг",
	"predictions.points.totalPoints": "Общо точки",
	"predictions.points.currentPosition": "Текуща позиция",
	"predictions.points.points": "Точки",
	"predictions.points.totalPointsLabel": "Общо точки",
	"predictions.submitButton.submitting": "Изпращане...",
	"predictions.submitButton.predictionsSaved": "Прогнозите са запазени",
	"predictions.submitButton.updatePredictions": "Актуализирай прогнозите",
	"predictions.submitButton.submitAllPredictions": "Изпрати всички прогнози",
	"predictions.predictionCard.result": "Резултат",
	"predictions.predictionCard.pts": "Т.",

	//Predictions Info Card
	"predictions.infoCard.title": "Предскажи всеки резултат от мач и спечели награди!",
	"predictions.infoCard.description":
		"Кой ще излезе на върха? Колко гола ще вкарат? Предскажи сега и се състезавай с приятелите си! Прилагат се правила и общи условия.",
	"predictions.infoCard.playButton": "Играй сега",
	"predictions.infoCard.prizesButton": "Виж наградите",

	//Common Components
	"common.shareCard.title": "Покани приятелите си да играят",
	"common.shareCard.description":
		"Покани приятелите си да играят BW ScorePredict, за да видите кой от вас е най-добрият футболен мениджър и за да имате всички шанс да спечелите седмични награди!",
	"common.shareCard.button": "Покани приятели",
	"common.shareCard.shareTitle": "Изтегли BetwayScores",
	"common.shareCard.shareBody": "Изтегли BetwayScores и се състезавай с приятелите си в BW ScorePredict!",

	"common.accessDenied.title": "Изтегли приложението Betway Scores",
	"common.accessDenied.description":
		"За да получиш достъп до това съдържание, моля изтегли приложението Betway Scores. Получи най-новите резултати, прогнози и ексклузивни функции на върха на пръстите си.",
	"common.accessDenied.rulesText": "Достъпно за iOS и Android устройства. Изтегли сега, за да започнеш!",
	"common.accessDenied.button": "Изтегли приложението Betway Scores",

	"common.prizesInfoCard.title": "Информация за наградите",
	"common.prizesInfoCard.description1":
		"Не е нужно да имаш Betway акаунт, за да играеш BW ScorePredict, но за да получиш седмична награда, като влезеш в Топ 10 в която и да е седмица, трябва да имаш Betway акаунт, за да бъдат депозирани тези печалби.",
	"common.prizesInfoCard.description2": "Виж Правилата и Общите условия на играта за подробности за седмичните и общите награди.",
	"common.prizesInfoCard.button": "Виж правилата",

	//Prizes Fragment
	"prizes.prizeCard1.title": "Главна награда – Гледай Арсенал на стадион Емиратс",
	"prizes.prizeCard1.description":
		"Спечели пътуване за двама, за да гледаш Арсенал на стадион Емиратс в Лондон, включително полети (ако е необходимо), настаняване (ако е необходимо) и £500 джобни пари.",
	"prizes.prizeCard2.title": "Победител в рунда – Парична награда в твоя Betway акаунт",
	"prizes.prizeCard2.description":
		"Най-добрият играч всяка седмица ще спечели €150 (или валутен еквивалент – виж секция 'Правила') като пари, депозирани в неговия Betway акаунт.",
	"prizes.prizeCard3.title": "Места 2-10 всяка рунда – Парична награда в твоя Betway акаунт",
	"prizes.prizeCard3.description":
		"Тези, които завършат от 2-ро до 10-то място всяка седмица, също ще получат парични награди в своя Betway акаунт. Виж секция 'Правила' за точните суми, които можеш да спечелиш.",

	"common.modal.pointsFormat": "+{points}т.",

	//Betway Account Fragment
	"betwayAccount.title": "Отвори Betway акаунт",
	"betwayAccount.description":
		"Не е нужно да имаш Betway акаунт, за да играеш BW ScorePredict, но за да получиш седмична награда, като влезеш в Топ 10 в която и да е седмица, трябва да имаш Betway акаунт, за да бъдат депозирани тези печалби.",
	"betwayAccount.rulesText": "Виж Правилата и Общите условия на играта за подробности за седмичните и общите награди.",
	"betwayAccount.button": "Отвори Betway акаунт",
};
